var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordSprayAttack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5540_88335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 21H31V19C31 16.24 28.76 14 26 14C23.24 14 21 16.24 21 19V21H20C18.9 21 18 21.9 18 23V33C18 34.1 18.9 35 20 35H32C33.1 35 34 34.1 34 33V23C34 21.9 33.1 21 32 21ZM22.9 19C22.9 17.29 24.29 15.9 26 15.9C27.71 15.9 29.1 17.29 29.1 19V21H22.9V19Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 24,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 28,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 34,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 28,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 22,
    r: 1,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 17 23)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 17 27)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 17 31)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 14 33)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 14 27)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 14 21)",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5540_88335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white",
    transform: "translate(12 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSprayAttack);
export default __webpack_public_path__ + "static/media/password_spray_attack.96cac7f134b758ee98ef3af226ec3da0.svg";
export { ForwardRef as ReactComponent };